import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { Icon } from "./../Common/Icon";
import { PanelHeader, PanelHeaderDropdown } from "./../Layout/Panel";

export default class PanelTitle extends PureComponent {
  static propTypes = {
    billsOfLading: PropTypes.array.isRequired,
    onSelectCurrentBillOfLading: PropTypes.func.isRequired,
    selectedBillOfLading: PropTypes.object.isRequired,
    documentClick: PropTypes.func,
    isMobile: PropTypes.bool,
    routingClick: PropTypes.func,
    summaryButtonClick: PropTypes.func,
    summaryIsLoading: PropTypes.bool
  };

  static defaultProps = {
    isMobile: false,
    documentClick: null,
    routingClick: null,
    summaryButtonClick: null,
    summaryIsLoading: false
  };

  state = {
    isPanelHeaderDropdownOpen: false,
    isTitleDarkOversized: false
  };

  componentDidUpdate() {
    if (document.querySelector(".panel-header__title-dark").innerText.length >= 20) {
      this.handleOversizedTitleDark();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleTogglePanelHeaderDropdown);
  }

  getPanelHeaderDropdown = () => ({
    isOpen: this.state.isPanelHeaderDropdownOpen,
    onClick: this.handleTogglePanelHeaderDropdown,
    items: this.props.billsOfLading.map(billOfLading => ({
      id: billOfLading.id,
      onClick: this.props.onSelectCurrentBillOfLading,
      label: billOfLading.shipmentId || ""
    }))
  });

  actions = [
    {
      label: i18n.t("billsOfLading.documents"),
      icon: "file",
      onClick: this.props.documentClick,
      className: "--right"
    },
    {
      label: i18n.t("billsOfLading.routing"),
      icon: "truck",

      onClick: this.props.routingClick,
      className: "--routing"
    }
  ];

  closeDropdowns = () => {
    this.setState({ isPanelHeaderDropdownOpen: false });
    document.removeEventListener("click", this.closeDropdowns);
  };

  handleTogglePanelHeaderDropdown = () => {
    this.setState({ isPanelHeaderDropdownOpen: !this.state.isPanelHeaderDropdownOpen });
    document.addEventListener("click", this.closeDropdowns);
  };

  handleOversizedTitleDark = () => {
    this.setState({ isTitleDarkOversized: true });
  };

  renderPanelTitle = () => {
    const dropdownInfo = this.getPanelHeaderDropdown();

    return (
      <div className="panel-header__title-container panel-header__id">
        <span className={classNames("panel-header__title-dark", this.state.isTitleDarkOversized && "--oversized")}>
          {i18n.t("loads.load")} {this.props.selectedBillOfLading.loadId || ""}
          <Icon className="panel-header__title-arrow" id="arrow-down" />
        </span>
        <div role="button" tabIndex="0" className="panel-header__title-dropdown" onClick={dropdownInfo.onClick}>
          {this.props.selectedBillOfLading.shipmentId || ""}
          {this.props.billsOfLading.length > 1 && <PanelHeaderDropdown items={dropdownInfo.items} isOpen={dropdownInfo.isOpen} />}
        </div>
      </div>
    );
  };

  render() {
    const { isMobile, summaryButtonClick, summaryIsLoading } = this.props;

    return (
      <PanelHeader
        title={i18n.t("billsOfLading.billsOfLading")}
        customLabel={this.renderPanelTitle()}
        actions={this.actions}
        isMobile={isMobile}
        summaryButtonClick={summaryButtonClick}
        summaryIsLoading={summaryIsLoading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BillOfLading/PanelTitle.js